import { types } from './options';

const momentValue = (value, type = types.date.id) =>
  value && type ? types[type].formater(value) : undefined;

export default momentValue;
